import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RetornoSelecao } from '../../../shared/gridview/RetornoSelecao';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnaliseGarantiaService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;
  private httpClient: HttpClient;

  @Output() exibir: EventEmitter<RetornoSelecao> = new EventEmitter<RetornoSelecao>();

  constructor(http: HttpClient, router: Router, protected toastr: ToastrService) {
    super(http, router);
    this.httpClient = http;
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return `${this.baseUrlService}/analise_garantia`
  }

  public buscar(filtros: any): Promise<any> {
    const headers = new HttpHeaders({ 'Authorization': this.getToken() });
    let params = new HttpParams();
    if (filtros) {
      Object.keys(filtros).forEach(key => {
        const value = filtros[key];
        if (value !== undefined && value !== null && value !== '') {
          params = params.set(key, String(value));
        }
      });
    }

    return this.httpClient.get(this.getURL(), { headers, params })
      .toPromise()
      .then(this.tratarRetorno);
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;

    console.error(error);

    let texto: string;
    try {
      texto = error.erro ? mensagem + '\n' + error.erro : mensagem;
    } catch (Exception) {
      texto = mensagem;
    }

    this.toastr.error(texto, titulo, error);

    if (error.status === 401) {
      this.router.navigateByUrl('logout');
    }
  }

  public ver(registro: RetornoSelecao) {
    this.carregarModel(registro)
      .then(res => {
        registro = res;
        this.exibir.emit(registro);
      })
      .catch(error => this.tratarErro('Não foi possível carregar o registro.', 'Erro', error));
  }

  protected carregarModel(registro: any): Promise<any> {
    return Promise.resolve(registro);
  }

  private getUser(): string {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    return currentUser ? currentUser.username : '';
  }

  public analisar(dadosAnalise: any): Promise<any> {
    const headers = new HttpHeaders({ 
      'Authorization': this.getToken(),
      'Content-Type': 'application/json'
    });

    return this.httpClient.post(`${this.getURL()}/analise`, dadosAnalise, { headers })
      .toPromise()
      .then(this.tratarRetorno)
      .catch(error => {
        this.tratarErro('Não foi possível processar a análise.', 'Erro', error);
        throw error;
      });
  }

  public verificarPermissaoUsuario(): Promise<boolean> {
    const headers = new HttpHeaders({ 
      'Authorization': this.getToken(),
      'Content-Type': 'application/json'
    });

    return this.httpClient.get(`${this.getURL()}/usuario_fabrica`, { headers })
      .toPromise()
      .then((res: any) => {
        return res === true || res === 'true';
      })
      .catch(error => {
        console.error('Erro ao verificar permissão do usuário:', error);
        return false;
      });
  }

}
